import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=2d60fb72&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=2d60fb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60fb72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d60fb72')) {
      api.createRecord('2d60fb72', component.options)
    } else {
      api.reload('2d60fb72', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=2d60fb72&scoped=true&", function () {
      api.rerender('2d60fb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Filters.vue"
export default component.exports